import { hasRequiredFields } from '@move-frontend/utils';
import { IResetPasswordFormData } from '../../../domain/models/IResetPasswordFormData';
import { useResetPasswordFormContext } from './useResetPasswordFormContext';

export function useResetPasswordHasRequiredFields() {
	const { watch } = useResetPasswordFormContext();
	const values: Partial<IResetPasswordFormData> = watch();

	return hasRequiredFields(values, ['password', 'confirmPassword']);
}
